export const KEY_LOCAL_STORAGE_TOKEN = 'token'
export const KEY_LOCAL_STORAGE_USER_INFO = 'user_info'
export const errorsAuthUser = [
  'INVALID_EMAIL_FORMAT',
  'INVALID_AVT_ROLE_ID',
  'INVALID_CLIENT_NUMBER',
  'CLIENT_NOT_FOUND',
  'AVT_ROLE_NOT_FOUND',
  'INVALID_STORE_IDS_FORMAT'
]
